import { render, staticRenderFns } from "./MFixedAssetEditorFieldset.yaml?vue&type=template&id=e4f28630&component"
import script from "./MFixedAssetEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./MFixedAssetEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports